var map = {
	"./landscape_autofill.png": 41527,
	"./landscape_fillyourself.png": 62717,
	"./portrait_autofill.png": 92770,
	"./portrait_fillyourself.png": 86255,
	"./square_autofill.png": 93193,
	"./square_fillyourself.png": 97459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96953;